module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('game-map'), _vm._v(" "), (_vm.event && _vm.team && _vm.menuOpen) ? _c('game-menu') : _vm._e(), _vm._v(" "), (!_vm.event) ? _c('event-selection') : _vm._e(), _vm._v(" "), (_vm.event && !_vm.team) ? _c('team-selection') : _vm._e(), _vm._v(" "), (_vm.point) ? _c('point') : _vm._e(), _vm._v(" "), (!_vm.point && _vm.finished) ? _c('finish') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a618997!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app.vue
// module id = 370
// module chunks = 0